import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button, Form, Image } from 'react-bootstrap';
import axios from 'axios';
import { useSelector } from "react-redux";
import { persistor, RootState } from "../store";
import { Link, useNavigate } from 'react-router-dom';
import { signOut, updatePassword } from 'aws-amplify/auth';

const ResetPassword: React.FC = () => {
    const { vendorInfo } = useSelector((state: RootState) => state.vendor);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [passwordCheck, setPasswordCheck] = useState('');
    const navigate = useNavigate();

    const handleUpdatePassword = async () => {
        if (!oldPassword || !newPassword || !passwordCheck) {
            alert('すべての項目を入力してください。');
            return;
        }
        if (newPassword !== passwordCheck) {
            alert('パスワードの確認が一致していません。');
            return;
        }
        try {
            await updatePassword({ oldPassword, newPassword });
            persistor.purge();
            await signOut({ global: true });
            navigate('/reset_password_completed');
        } catch (error: any) {
            console.log(error);
            if (error.name === 'NotAuthorizedException') {
                alert('現在のパスワードが正しくありません。');
            } else if (error.name === 'LimitExceededException') {
                alert('リクエスト回数の上限を超えました。しばらくしてから再度お試しください。');
            } else {
                alert('パスワードの変更に失敗しました。');
            }
        }
    }

    return (
        <>

            <>
                <section className="">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 col-md-10 mx-auto">
                                <div className="login-wrapper py-lg-5 py-3 text-center">
                                    <Image className="height-90 mb-2" src="assets/images/other/icon-user-bg-white-circle-blue.svg" />
                                    <div className="text-md mb-sm-4 mb-3 fw-400">アカウント情報を入力</div>
                                    <Form className="form-theme password-match-form" method="POST">

                                        <Form.Control type="hidden" name="id" />
                                        <div className="border-bottom-5-blue-04"></div>
                                        <div className="bg-ass-demo p-lg-5 p-3 mb-lg-5 mb-sm-4 mb-3">
                                            <div className="col-lg-8 col-11 px-0 mx-auto">
                                                <Form.Group className="form-group text-left mb-4">
                                                    <Form.Label htmlFor="name1">
                                                        現在パスワード
                                                        <Image className="img img-fluid required-icon" src="assets/images/registration/required-icon.svg" />
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="password" className="form-control"
                                                        name="password" id="password"
                                                        placeholder="現在パスワードを入力" required minLength={8}
                                                        value={oldPassword}
                                                        onChange={(e) => setOldPassword(e.target.value)}
                                                    />
                                                </Form.Group>
                                                <Form.Group className="form-group text-left mb-4">
                                                    <Form.Label htmlFor="name1">
                                                        新しいパスワード
                                                        <Image className="img img-fluid required-icon" src="assets/images/registration/required-icon.svg" />
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="password" className="form-control"
                                                        name="password" id="password"
                                                        placeholder="新しいパスワードを入力" required minLength={8}
                                                        value={newPassword}
                                                        onChange={(e) => setNewPassword(e.target.value)}
                                                    />
                                                </Form.Group>
                                                <Form.Group className="form-group text-left mb-4">
                                                    <Form.Label htmlFor="name33">
                                                        新しいパスワード(確認)
                                                        <Image className="img img-fluid required-icon" src="assets/images/registration/required-icon.svg" />
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="password" className="form-control"
                                                        name="passwordConfirm" id="passwordConfirm"
                                                        placeholder="パスワードをもう一度入力" required minLength={8}
                                                        value={passwordCheck}
                                                        onChange={(e) => setPasswordCheck(e.target.value)}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </div>
                                        <Button onClick={handleUpdatePassword} className="btn-theme btn-danger rounded-pill px-lg-5 px-4"><span className="px-lg-5 px-4">変更する</span></Button>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
            <Footer />
        </>
    )
}

export default ResetPassword;